"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventSearchEpic = void 0;
var redux_observable_1 = require("redux-observable");
var eventSearch_1 = require("../actions/internal/eventSearch");
var rxjs_1 = require("rxjs");
var types_1 = require("../actions/internal/types");
var operators_1 = require("rxjs/operators");
var util_1 = require("./util");
var queries_1 = require("./util/queries");
function eventSearchEpic(actions$) {
    return actions$.pipe(redux_observable_1.ofType(types_1.InternalClientActionType.EVENT_SEARCH), operators_1.flatMap(function (action$) {
        var args = action$.args;
        return rxjs_1.from(util_1.waitForData(args, queries_1.eventSearchQueryBuilder, eventSearch_1.eventSearchCompleteInternal, eventSearch_1.eventSearchErrorInternal)).pipe(operators_1.catchError(function (err) { return rxjs_1.of(err); }));
    }), operators_1.catchError(function (err) { return rxjs_1.of(err); }));
}
exports.eventSearchEpic = eventSearchEpic;
//# sourceMappingURL=eventSearchEpic.js.map